var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLimitations = function SvgLimitations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#141B34",
    strokeWidth: 2.5,
    d: "M13.999 25.667c6.443 0 11.666-5.223 11.666-11.666S20.442 2.334 14 2.334 2.332 7.557 2.332 14.001c0 6.443 5.223 11.666 11.667 11.666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M10.955 17.69c.588.393 1.408.393 3.046.393 1.639 0 2.458 0 3.047-.394.254-.17.473-.389.643-.643.394-.589.394-1.408.394-3.047 0-1.638 0-2.458-.394-3.046a2.3 2.3 0 0 0-.643-.644c-.589-.393-1.408-.393-3.047-.393-1.638 0-2.457 0-3.046.393-.255.17-.474.39-.644.644-.393.588-.393 1.408-.393 3.046 0 1.639 0 2.458.393 3.047.17.254.39.473.644.643"
  })));
};
export default SvgLimitations;